const LOW_RES_MAX_NATURAL_WIDTH = 128

export function isLowResCover(image: HTMLImageElement | null, src: string): boolean {
  if (!image) return false
  if (src.startsWith('data:')) return false
  return image.naturalWidth > 0 && image.naturalWidth < LOW_RES_MAX_NATURAL_WIDTH
}
